import { useEffect } from "react";
import Badges from "../../components/common/badges";
import MoneyBackGuarantee from "../../components/common/money-back-guarantee";
import ActNow from "../../components/glucogen/downsell/act-now";
import BuyingTime from "../../components/glucogen/downsell/buying-time";
import DontStop from "../../components/glucogen/downsell/dont-stop";
import FeltChanges from "../../components/glucogen/downsell/felt-changes";
import FinalOpportunity from "../../components/glucogen/downsell/final-opportunity";
import KeptAsking from "../../components/glucogen/downsell/kept-asking";
import LastTime from "../../components/glucogen/downsell/last-time";
import Offer from "../../components/glucogen/downsell/offer";
import ThisMatters from "../../components/glucogen/downsell/this-matters";
import Title from "../../components/glucogen/downsell/title";
import TooMuch from "../../components/glucogen/downsell/too-much";
import Gifts from "../../components/glucogen/upsell/gifts";
import usePageTracking from "../../utils/gtm-page-tracking";
import { ggProductName } from "../../data/product";
import useBuyTracking from "../../utils/gtm-buy-tracking";
import TestimonialsDownsell3 from "../../components/glucogen/downsell/testimonials-downsell-3";

const DownsellGlucoGen3 = () => {
    usePageTracking();
    useBuyTracking();
    useEffect(() => {
        const script1 = document.createElement('script');
        script1.innerHTML = `
            var mysrc = "https://tracking.buygoods.com/track/?a=11273&firstcookie=0"+"&tracking_redirect=&referrer="+encodeURIComponent(document.referrer)+"&sessid2="+ReadCookie('sessid2')+"&product=glu3d&vid1=&vid2=&vid3=&caller_url="+encodeURIComponent(window.location.href); if(typeof add_to_cart !== 'undefined') { mysrc = mysrc+'&add_to_cart='+add_to_cart; } var newScript = document.createElement('script'); newScript.type = 'text/javascript'; newScript.defer = true; newScript.src = mysrc; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(newScript, s); function ReadCookie(name){name += '='; var parts = document.cookie.split(/;\s*/);for (var i = 0; i < parts.length; i++) {var part = parts[i]; if (part.indexOf(name) == 0) return part.substring(name.length)} return '';}
        `;
        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.innerHTML = `
            var i = document.createElement("iframe"),oid = new URLSearchParams(window.location.search);i.async = true;i.style="display:none";i.setAttribute("src", "https://buygoods.com/affiliates/go/conversion/iframe/bg?a=11273&t=d9e2485e36c8c19cbfc7f6acfe589a47&conversion=1&s="+ReadCookie('sessid2')+"&o="+oid.get('order_id_global')+"&ut="+oid.get('token'));document.body.appendChild(i);
        `;
       
        document.head.appendChild(script1);
        document.head.appendChild(script2);

        return () => {
            document.head.removeChild(script1);
            document.head.removeChild(script2);
        };
    }, []);

    return (
        <>
            <Title />
            <TooMuch />
            <KeptAsking />
            <FeltChanges />
            <FinalOpportunity />
            <DontStop />
            <Offer />
            <Badges />
            <TestimonialsDownsell3 />
            <ThisMatters />
            <BuyingTime />
            <Gifts />
            <LastTime />
            <MoneyBackGuarantee
                backgroundClass="gg-bg-gradient-rb-h"
                productName={ggProductName}
            />
            <ActNow />
        </>
    );
}

export default DownsellGlucoGen3;
